/**
 * Generates a random password with the specified length
 * @param {number} length - The length of the password (default: 10)
 * @returns {string} - A randomly generated password
 */
export function generatePassword(length = 10) {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+';
  let password = '';
  for (let i = 0; i < length; i++) {
    password += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return password;
} 